import axios from "../../axios";

const update = async function (accessToken,data = {}) {
    try {
        const response = await axios.post('admin/pay-in/update', data,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default update;
